import React, {
	createContext,
	useState,
	useContext,
	useEffect,
	useMemo,
} from 'react';
import {useTopStickySectionContext} from './TopStickySectionContext';
import {numericalSort} from 'helpers/sortHelpers';

const MIN_TOP_GAP = 45;
const BETWEEN_GAP = 0;
export const TopStickySection: React.FC = () => {
	const {stickyChildren, setHeightStickySection} = useTopStickySectionContext();

	const stickyChildrenSorted = useMemo(
		() =>
			numericalSort(stickyChildren, 'sortPriority')
				.filter(x => !x.isHidden)
				.map(x => x.stickyObject),
		[stickyChildren],
	);

	useEffect(() => {
		const arrHeights = stickyChildren
			.filter(x => !x.isHidden)
			.map(x => x.height);
		const sumHeight = Math.max(
			arrHeights.reduce(
				(accumulator, currentValue) => accumulator + currentValue + BETWEEN_GAP,
				MIN_TOP_GAP,
			),
			MIN_TOP_GAP,
		);
		setHeightStickySection(sumHeight);
	}, [stickyChildren]);
	return <>{stickyChildrenSorted}</>;
};
